import { languages } from '../core.js';
import { createT4 } from '../utils/t4-templating.js';
import './vbnet.js';

languages['t4-vb'] = createT4('vbnet');
